// Generated by scripts/build-ui-icons.mjs.
export { ChartLineUp as default } from "../ui/glyphs-2";
